'use strict';

export class brWpParticipant
{
	initial = 0;
	proposed = 0;
	reduction = 0;
	comment = '';
	title = '';
	participant_id;
	id;
	
	constructor(data){
		this.setupData(data);
	}
	
	setupData(data){
		if(typeof(data.initial) !== 'undefined' && !isNaN(data.initial)){
			this.initial = parseFloat(data.initial);
		}
		if(typeof(data.proposed) !== 'undefined' && !isNaN(data.proposed)){
			this.proposed = parseFloat(data.proposed);
		}
		if(typeof(data.reduction) !== 'undefined' && !isNaN(data.reduction)){
			this.reduction = parseFloat(data.reduction);
		}
		if(typeof(data.comment) !== 'undefined' && data.comment !== ''){
			this.comment = data.comment;
		}
		if(typeof(data.participant_id) !== 'undefined'){
			this.participant_id = data.participant_id;
		}
		if(typeof(data.title) !== 'undefined' && data.title !== ''){
			this.title = data.title;
		}
		this.id = 'p'+this.participant_id;
	}
	
	calcReduction(){
		if(!this.initial || isNaN(this.initial)){
			this.proposed = 0;
			return;
		}
		if(!this.reduction || isNaN(this.reduction) || !(this.reduction > 0)){
			this.proposed = this.initial;
			return;
		}
		this.proposed = this.initial - this.reduction;
//		
//		if(!this.initial || isNaN(this.initial)){
//			this.reduction = 0;
//			return;
//		}
//		if(!this.proposed || isNaN(this.proposed)){
//			this.reduction = this.initial;
//			return;
//		}
//		if(this.proposed > this.initial){
//			this.reduction = 0;
//			return;
//		}
//		this.reduction = this.initial - this.proposed;
		return;
	}
	
	getReduction(){
		this.calcReduction();
		return this.reduction;
	}
	getProposed(){
		this.calcReduction();
		return this.proposed;
	}
	
	setProposed(sum){
		if(isNaN(sum)){
			return;
		}
		if(sum < 0){
			return;
		}
		this.proposed = parseFloat(sum);
		this.reduction = this.initial - this.proposed;
	}
}